<template>
  <v-card class="px-0 py-2 d-flex justify-center align-center" outlined>
    <div>
      <h2
        class="text-h4 font-weight-black text-color text-center"
        v-if="type == 'price' && text == 'total-points-spent'"
      >
        {{
          toShow == 0 || toShow < 0
            ? 0
            : Math.ceil(toShow).toLocaleString("fr-FR")
        }}
        pts
      </h2>
      <h2
        class="text-h4 font-weight-black text-color text-center"
        v-else-if="type == 'price'"
      >
        {{
          toShow == 0 || toShow < 0
            ? toShow.toLocaleString("fr-FR")
            : Math.ceil(toShow).toLocaleString("fr-FR")
        }}
        €
      </h2>
      <h2
        class="text-h4 font-weight-black text-color text-center"
        v-else-if="
          (this.type == 'number' && this.text == 'estimated-growth') ||
          this.text == 'total-margin' ||
          this.text == 'total-margin-point'
        "
      >
        {{ toShow.toLocaleString("fr-FR") }} %
      </h2>
      <h2
        class="text-h4 font-weight-black text-color text-center"
        v-else-if="this.type == 'number'"
      >
        {{ toShow.toLocaleString("fr-FR") }}
      </h2>

      <div class="text-body-2 mt-2 text-center">
        {{ this.$t("kpi." + this.text) }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "StatisticsCard",
  props: {
    toShow: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "Total",
    },
  },
  data() {
    return {
      numberTotal: 4,
    };
  },
};
</script>
